import { AppBarDataProps } from "@pages/wrapper/appBar/appBar.interface";

export const tabData: AppBarDataProps[] = [
  {
    id: 1,
    title: "Machine",
  },
  {
    id: 2,
    title: "Process",
  },
];
